import { formatNumber } from '@/common/utils/formatting'

export const formatDistance = (count: number) => (count ? formatNumber(count, 2) : 'n/a')

export const formatCount = (count: number) => {
  if (count > 0 && count < 0.1) return '0.1'
  if (count > 0 && count < 1) return formatNumber(count, 1)
  return formatNumber(count)
}
